"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReorderAreaLibrariesMutation = exports.useDeleteAreaLibraryMutation = exports.useUpdateAreaLibraryMutation = exports.useCreateAreaLibraryMutation = exports.useGetAreaLibrariesQuery = exports.areaLibraryApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.areaLibraryApi = (0, react_1.createApi)({
    reducerPath: "areaLibraryApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["area-library"],
    endpoints: function (builder) { return ({
        getAreaLibraries: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/area-library"),
            providesTags: ["area-library"],
        }),
        createAreaLibrary: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId, name = _a.name;
                return ({ url: "/v1/area-library", method: "POST", body: { client_id: clientId, name: name } });
            },
            invalidatesTags: ["area-library"],
        }),
        updateAreaLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id, name = _a.name;
                return ({ url: "/v1/area-library/".concat(id), method: "PATCH", body: { name: name } });
            },
            invalidatesTags: ["area-library"],
        }),
        deleteAreaLibrary: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return ({ url: "/v1/area-library/".concat(id), method: "DELETE" });
            },
            invalidatesTags: ["area-library"],
        }),
        reorderAreaLibraries: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId, items = _a.items;
                return ({ url: "/v1/area-library/reorder", method: "PATCH", body: { client_id: clientId, items: items } });
            },
            invalidatesTags: ["area-library"],
        }),
    }); },
});
exports.useGetAreaLibrariesQuery = exports.areaLibraryApi.useGetAreaLibrariesQuery, exports.useCreateAreaLibraryMutation = exports.areaLibraryApi.useCreateAreaLibraryMutation, exports.useUpdateAreaLibraryMutation = exports.areaLibraryApi.useUpdateAreaLibraryMutation, exports.useDeleteAreaLibraryMutation = exports.areaLibraryApi.useDeleteAreaLibraryMutation, exports.useReorderAreaLibrariesMutation = exports.areaLibraryApi.useReorderAreaLibrariesMutation;
